[
    {
        "header": "Order Date time",
        "field": "dateRange",
        "datatype": "DateTime",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "Side",
        "field": "buySellCode",
        "datatype": "choice",
        "dropdown": "YES",
        "value": "Enter Value",
        "dropdownvalue": [
            {
                "label": "None",
                "value": ""
            },
            {
                "label": "B-(buy)",
                "value": "B"
            },
            {
                "label": "SL-(sell long)",
                "value": "SL"
            },
            {
                "label": "SS-(short sale)",
                "value": "SS"
            },
            {
                "label": "SX-(short sale exempt)",
                "value": "SX"
            }
        ]
    },
    {
        "header": "Routed Order ID",
        "field": "routedOrderID",
        "datatype": "String",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "Sent TO Routed Order ID",
        "field": "sentToRoutedOrderID",
        "datatype": "String",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "Record Type",
        "field": "recordType",
        "datatype": "String",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "order Receiving Date",
        "field": "orderReceivingDate",
        "datatype": "String",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "firm Order ID",
        "field": "firmOrderID",
        "datatype": "String",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "barrier ID",
        "field": "barrierID",
        "datatype": "Int",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "desk Rec Timestamp",
        "field": "deskRecTimestamp",
        "datatype": "DateTime",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "desk Share Qty",
        "field": "deskShareQty",
        "datatype": "Int",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "desk Type Code",
        "field": "deskTypeCode",
        "datatype": "choice",
        "dropdown": "YES",
        "value": "Enter Value",
        "dropdownvalue": [
            {
                "label": "None",
                "value": ""
            },
            {
                "label": "A-(Agency)",
                "value": "A"
            },
            {
                "label": "AR-(Arbitrage)",
                "value": "AR"
            },
            {
                "label": "B-(Block Trading)",
                "value": "B"
            },
            {
                "label": "C-(Convertible Desk)",
                "value": "C"
            },
            {
                "label": "CR-(Central Risk Books)",
                "value": "CR"
            },
            {
                "label": "D-(Derivatives)",
                "value": "D"
            },
            {
                "label": "EC-(Equity Capital Markets)",
                "value": "EC"
            },
            {
                "label": "IN-(International)",
                "value": "IN"
            },
            {
                "label": "IS-(Institutional)",
                "value": "IS"
            },
            {
                "label": "O-(Other)",
                "value": "O"
            },
            {
                "label": "PF-(Preferred Trading)",
                "value": "PF"
            },
            {
                "label": "PR-(Proprietary)",
                "value": "PR"
            },
            {
                "label": "PT-(Program Trading)",
                "value": "PT"
            },
            {
                "label": "S-(Sales)",
                "value": "S"
            },
            {
                "label": "SW-(Swaps)",
                "value": "SW"
            },
            {
                "label": "T-(Trading)",
                "value": "T"
            },
            {
                "label": "TR-(Treasury)",
                "value": "TR"
            }
        ]
    },
    {
        "header": "Action Type Code",
        "field": "actionTypeCode",
        "datatype": "choice",
        "dropdown": "YES",
        "value": "Enter Value",
        "dropdownvalue": [
            {
                "label": "None",
                "value": ""
            },
            {
                "label": "C-(correct)",
                "value": "C"
            },
            {
                "label": "D-(delete)",
                "value": "D"
            },
            {
                "label": "N-(new)",
                "value": "N"
            },
            {
                "label": "R-(replacement)",
                "value": "R"
            }
        ]
    },
    {
        "header": "Firm ROE ID",
        "field": "firmRoeID",
        "datatype": "Int",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "Correction Deletion Timestamp",
        "field": "correctionDeletionTimestamp",
        "datatype": "DateTime",
        "dropdown": "NO",
        "value": "Enter Value",
        "dropdownvalue": ""
    },
    {
        "header": "Resubmit",
        "field": "resubmit",
        "datatype": "choice",
        "dropdown": "YES",
        "value": "Enter Value",
        "dropdownvalue": [
            {
                "label": "None",
                "value": ""
            },
            {
                "label": "Y-(yes)",
                "value": "Y"
            }
        ]
    }
]